// Sniff It theme — small helpers
(function () {
  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = btn.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
  });

  // Variant select: keep price + button in sync
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    var dataEl = form && form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      var price = document.querySelector('[data-product-price]');
      if (price) price.textContent = v.price_formatted;
      var btn = form.querySelector('[data-add-button]');
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-add-label') : btn.getAttribute('data-soldout-label');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.hasAttribute('open');
      if (open) { nav.removeAttribute('open'); } else { nav.setAttribute('open', ''); }
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }
})();
